import React from 'react'
import {FiLinkedin} from 'react-icons/fi'
import {FaHackerrank,FaStackOverflow,FaGithub} from 'react-icons/fa'
import {SiLeetcode} from 'react-icons/si'

export default function SocialSection() {
    return (
        <>
            <h1>Bhushan Verma</h1>
            <ul className="social-icons">
                <li><a title='linkedin' href="https://www.linkedin.com/in/bhushanverma1998/"><FiLinkedin /></a></li>
                <li><a title='stackoverflow' href="https://stackoverflow.com/users/20870344/bhushan-verma"><FaStackOverflow /></a></li>
                <li><a title='HackerRank' href="https://www.hackerrank.com/bhushanverma_ve1"><FaHackerrank /></a></li>
                <li><a title='Github' href="https://github.com/bhushanverma1998"><FaGithub /></a></li>
                <li><a title='Leetcode' href="https://leetcode.com/bhushanbawana/"><SiLeetcode /></a></li>
            </ul>
        </>
    )
}
